// this component is used as hero in most pages, so let's optimise it and not use suspense
import { withSuspense } from 'components/Decorators';
import { lazy } from 'react';
import Fallback from './BannerWithImage.fallback';

export default withSuspense(
  lazy(() => import('./BannerWithImage')),
  Fallback,
);
